import {Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DominiosService} from "../../services/dominios.service";
import {ConstantsService} from "../../services/ConstantsService";
import {SharedDataService} from "../../services/shared.data.service";
import {AutorizacaoLojaService} from "../../services/autorizacao-loja.service";
import {CarrinhoService} from "../../services/carrinho.service";
import {ComandaClienteService} from "../../services/comanda-cliente.service";

import {NavigationEnd, Router} from "@angular/router";
import {Subscription} from "rxjs";


@Component({
  selector: 'app-loja-menu',
  templateUrl: './loja-menu.component.html',
  styleUrls: ['./loja-menu.component.scss']
})
  export class LojaMenuComponent implements OnInit, OnDestroy {
  @Input() exibirMenu = true;
  @Output() onBuscarProdutos = new EventEmitter();
  @Output() onExibirBrindes = new EventEmitter();
  url: any = 'index';
  estaNoHome  = true;
  estaNaBuscaPorCategoria = false;
  exibirMenuCategorias = false;
  urlCardapio = '';
  exibirPoweredBy = false;
  usuario: any = {};
  estaNoLocal: boolean;
  evtEmpresa: Subscription;
  evtPedido: Subscription;
  evtNavegacao: Subscription;
  empresa: any;
  pedido: any;
  comandaResumo: any;
  folhaContaAberta = false;
  itensContaExpandidos = false;
  carregandoConta = false;
  erroConta: string;
  avisoConta: string;
  solicitandoGarcomConta = false;
  private overflowBodyAnterior = '';

  constructor(private dominiosService: DominiosService, private constantsService: ConstantsService,
              private router: Router,
              public sharedDataService: SharedDataService, private autorizacao: AutorizacaoLojaService,
              private carrinhoService: CarrinhoService, private comandaClienteService: ComandaClienteService) { }

  ngOnInit(): void {
    this.usuario = this.autorizacao.getUsuario() || {}
    this.pedido = this.carrinhoService.obtenhaPedido();

    this.autorizacao.usuario$.subscribe( (usuario) => {
      if(!usuario) return;
      this.usuario = usuario;
    });

    this.evtEmpresa = this.constantsService.empresa$.subscribe((empresa) => {
      if (!empresa) return

      this.empresa = empresa;
    });

   let link = this.dominiosService.obtenhaUrlAtiva();

   if(link !== '') this.url = link;

   this.urlCardapio = location.hostname;

   if( this.urlCardapio.indexOf('meucardapio.ai') !== -1 || this.urlCardapio.indexOf('localhost') !== -1 ) {
     this.exibirPoweredBy = true;
   }

   this.constantsService.empresa$.subscribe( (empresa: any) => {
     if( !empresa) {
       return;
     }

     if( !this.exibirPoweredBy ) this.exibirPoweredBy = empresa.rede === 'chinainbox';
   })

    this.evtPedido = this.carrinhoService.alterouPedido.subscribe((pedido) => {
      const tinhaItensNoCarrinho = Number(this.pedido?.qtde || 0) > 0;
      this.pedido = pedido;
      if(this.pedido?.comandaValidada?.idComanda && Number(this.pedido.qtde || 0) === 0 &&
        (tinhaItensNoCarrinho || !this.comandaResumo))
        this.carregueResumoConta();
    });

    if(this.pedido?.comandaValidada?.idComanda)
      this.carregueResumoConta();

    this.evtNavegacao = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // A URL foi alterada, faça o que for necessário aqui

        const regex = /\/([^\/?]+)(?:\?.*)?$/;
        const match1 =  event.urlAfterRedirects.match(regex);
        console.log(match1)
        this.url = match1 ? match1[1] : '';
        this.veriqueMenuAtivo();
        this.fecheConta();
        if(this.pedido?.comandaValidada?.idComanda)
          this.carregueResumoConta();
      }
    });

    this.veriqueMenuAtivo();
  }

  naveguePara(url: string) {
    this.url = url;
    this.veriqueMenuAtivo();
    this.dominiosService.navegueParaUrl(url);
  }

  navegueParaHome() {
    this.dominiosService.vaParaHome();
  }

  deveExibirBarraConta(): boolean {
    if(!this.exibirMenu || this.folhaContaAberta || (!this.comandaResumo && !this.erroConta) ||
      this.comandaResumo?.fechada)
      return false;

    if(Number(this.pedido?.qtde || 0) > 0 || (this.comandaResumo && this.quantidadeItensConta() === 0))
      return false;

    const caminho = location.pathname || '';
    return caminho.indexOf('/minha-comanda') === -1 && caminho.indexOf('/carrinho') === -1 &&
      caminho.indexOf('/pedido') === -1;
  }

  quantidadeItensConta(): number {
    return this.pedidosValidosConta().reduce((total: number, pedido: any) =>
      total + (pedido.itens || []).reduce((totalItens: number, item: any) =>
        totalItens + Number(item.qtde || 0), 0), 0);
  }

  pedidosValidosConta(): any[] {
    return (this.comandaResumo?.pedidos || []).filter((pedido: any) =>
      !pedido.cancelado && [7, 8].indexOf(Number(pedido.statusOrdem)) === -1);
  }

  podePagarPixConta(): boolean {
    return !!(this.comandaResumo?.pixOnlineDisponivel && Number(this.comandaResumo?.saldoPagar || 0) > 0);
  }

  alterneItensConta(): void {
    this.itensContaExpandidos = !this.itensContaExpandidos;
  }

  pagamentosConfirmadosConta(): any[] {
    return (this.comandaResumo?.pagamentos || []).filter((pagamento: any) =>
      [0, 3].indexOf(Number(pagamento.statusNumero)) >= 0);
  }

  carregueResumoConta(): void {
    if(this.carregandoConta || !this.pedido?.comandaValidada?.idComanda)
      return;

    this.carregandoConta = true;
    this.erroConta = null;
    this.comandaClienteService.obtenhaMinhaComanda(this.pedido).then((comanda: any) => {
      this.comandaResumo = comanda;
      this.carregandoConta = false;
    }).catch((erro: any) => {
      this.erroConta = String(erro || 'Não foi possível atualizar sua conta.');
      this.carregandoConta = false;
    });
  }

  abraConta(): void {
    this.folhaContaAberta = true;
    this.itensContaExpandidos = false;
    this.avisoConta = null;
    this.overflowBodyAnterior = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    this.carregueResumoConta();
  }

  fecheConta(): void {
    if(!this.folhaContaAberta)
      return;

    this.folhaContaAberta = false;
    document.body.style.overflow = this.overflowBodyAnterior;
  }

  pagueComPix(): void {
    this.fecheConta();
    this.router.navigateByUrl(this.dominiosService.obtenhaUrlCompleta('minha-comanda'));
  }

  soliciteGarcomConta(): void {
    if(this.solicitandoGarcomConta)
      return;

    this.solicitandoGarcomConta = true;
    this.avisoConta = null;
    this.carrinhoService.soliciteFecharMesa().then(() => {
      this.solicitandoGarcomConta = false;
      this.avisoConta = 'Pedido de fechamento enviado. O garçom já foi avisado.';
    }).catch((erro: any) => {
      this.solicitandoGarcomConta = false;
      this.avisoConta = String(erro || 'Não foi possível chamar o garçom agora.');
    });
  }

  @HostListener('document:keydown.escape')
  aoPressionarEscape(): void {
    this.fecheConta();
  }

  veriqueMenuAtivo(){
    this.estaNoHome = this.url === 'index' || this.url === 'loja' || this.url === '/';
    this.estaNaBuscaPorCategoria = this.url.indexOf('busca') >= 0 &&  this.url.indexOf('ecommerce')
    this.estaNoLocal = this.url.indexOf('local') >= 0;
  }

  clicouExibirMenuCategorias(){
    this.sharedDataService.notifiqueExibirMenu();
  }

  busqueProdutos(){
    this.onBuscarProdutos.emit({})
  }

  exibirTelaBrindes(){
    this.onExibirBrindes.emit({})
  }

  ngOnDestroy(): void {
    if(this.evtEmpresa)
      this.evtEmpresa.unsubscribe();
    if(this.evtPedido)
      this.evtPedido.unsubscribe();
    if(this.evtNavegacao)
      this.evtNavegacao.unsubscribe();
    if(this.folhaContaAberta)
      document.body.style.overflow = this.overflowBodyAnterior;
  }
}
